import { forwardRef } from "react";
import classNames from "classnames";
import { Segmented } from "antd";
import type { SegmentedProps } from "antd/lib";
import styles from "./styles.module.scss";

type Props = SegmentedProps;

export const AppSegmented = forwardRef<HTMLDivElement, Props>(({ className, ...props }, ref) => {
  return <Segmented ref={ref} className={classNames(styles.segmented, className)} {...props} />;
});
